<div class="certificaciones-container">
  <h2 class="section-title">Certificación con validez profesional</h2>
  <p class="cert-text">
    La certificación emitida cumple con los requisitos formales establecidos por el Ministerio de Salud bajo el código <strong>DPRSA-UPR-0168-2023-S</strong>, al Ing. MSc. Dagoberto Eloy González López, cédula de identidad N° 801480648.
  </p>
  <a mat-raised-button color="accent" [href]="'https://wa.me/50672195203?text=Prad%20Academy,%20necesito%20ayuda.'" target="_blank">
   <mat-icon svgIcon="whatsapp"></mat-icon>
    ¿Ocupa ayuda?
  </a>
</div>
